const ACTION_POST_DATA = 'ACTION_POST_DATA'
const ACTION_POST_DATA_SUCCESS = 'ACTION_POST_DATA_SUCCESS'

export { ACTION_POST_DATA, ACTION_POST_DATA_SUCCESS }
